import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_BASE,
});

api.interceptors.request.use((cfg) => {
  // Prefer the superadmin token only on /superadmin/* requests.
  const sup = localStorage.getItem("pragma_super_token");
  const tok = localStorage.getItem("pragma_token");
  if (cfg.url && cfg.url.startsWith("/superadmin") && sup) {
    cfg.headers.Authorization = `Bearer ${sup}`;
  } else if (tok) {
    cfg.headers.Authorization = `Bearer ${tok}`;
  }
  return cfg;
});

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
